import React from 'react';
import { Input, Button, Link, Text, Box } from '@chakra-ui/react';
import { ordersByEmail } from '../api';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import RefundButton from '../components/RefundButton';

const Result = ({ id, createdAt, status, paymentId, settledBy, paymentType, onStatusUpdate }) => {
  const URL =
    window.location.hostname === 'localhost'
      ? 'http://localhost:3000'
      : 'https://' + window.location.hostname;

  const date = new Date(createdAt).toLocaleString('it', {
    month: 'long',
    day: 'numeric',
    year: '2-digit',
    hour: 'numeric',
    minute: 'numeric'
  });

  const handleRefundSuccess = () => {
    // Aggiorna lo stato dell'ordine localmente
    onStatusUpdate(id, 'refunded');
  };

  return (
    <Box p={1} my={3} border={'1px solid teal'} borderRadius={5}>
      <Box>
        <Link color={'gold'} href={URL + '/checkout-ok/' + id} isExternal>
          <Text>
            {id} <ExternalLinkIcon mx='2px' />
          </Text>
        </Link>
        <Text>creato il {date}</Text>
        <Text>status {status}</Text>
        {paymentType ? (
          <Text>paymentType {paymentType}</Text>
        ) : (
          <Text>paymentType STRIPE</Text>
        )}
        {/* Usa il nuovo componente RefundButton */}
        <RefundButton 
          orderId={id}
          paymentId={paymentId}
          status={status}
          settledBy={settledBy}
          onRefundSuccess={handleRefundSuccess}
          buttonProps={{ mt: 2 }}
        />
      </Box>
    </Box>
  );
};
function EmailInput() {
  const [isLoading, setIsLoading] = React.useState(false);
  const [email, setEmail] = React.useState('');
  const [error, setError] = React.useState('');
  const [orders, setOrders] = React.useState([]);
  
  const handleChange = (event) => {
    setError('');
    setOrders([]);
    setEmail(event.target.value);
  };

  const handleStatusUpdate = (orderId, newStatus) => {
    setOrders(prevOrders => 
      prevOrders.map(order => 
        order.id === orderId 
          ? { ...order, status: newStatus }
          : order
      )
    );
  };

  // console.log(orders);
  return (
    <>
      {error && (
        <Text fontSize={'lg'} color='tomato' mb={5}>
          {error}
        </Text>
      )}
      <Box maxH="400px" overflowY="auto">
        {orders.map((order, index) => (
          <Result key={index} {...order} settledBy={order.settledBy} onStatusUpdate={handleStatusUpdate} />
        ))}
      </Box>
      <Input my={5} value={email} onChange={handleChange} placeholder='email@email.com' size='sm' />
      <Button
        isLoading={isLoading}
        isDisabled={!email}
        onClick={async () => {
          setError('');
          setOrders([]);
          setIsLoading(true);
          const data = await ordersByEmail(email);
          // console.log('DATA', data); 
          setIsLoading(false);
          if (!data.orders.length) {
            setError('Nessun ordine trovato');
          } else {
            data.orders.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setOrders([...data.orders]);
          }
        }}
      >
        Cerca
      </Button>
    </>
  );
}

export default EmailInput;
